export const NUM_WEEK_PER_USER_CARD = 6;
